import { Base } from './base-model';

export class TeachingTool extends Base {
    // uuid: string
    name: string
    description: string
    contentType: string   // link, pdf, video
    category: string
    types: string
    collection: string
    tags: string
    url: string
    mediaImage: string

    typesList(): string[] {
        // return this.types.splitTrim()  // for some reason isn't working for this class????
        return this.types.split(',').map((value: string) => value.trim()).filter((value: string) => value.length > 0)
    }

    _firstType: string
    get firstType(): string {
        if (!this._firstType) {
            const sortedTypes = this.typesList().sort((a: string, b: string) => a.toLowerCase() < b.toLowerCase() ? -1 : 1)
            if (sortedTypes.length > 0) {
                this._firstType = sortedTypes[0]
            }
        }
        return this._firstType
    }

    // TODO: Implement the following as a mixin. THere are other models that use tagList(), tagsMatchAny, and xxxxWithTags(),
    // although they may need to override the default implementation

    tagsList(): string[] {
        return this.tags.split(',').map((value: string) => value.trim()).filter((value: string) => value.length > 0)
    }

    tagsMatchAny(tags: string[]): boolean {
        return this.tagsList().some ((toolTag: string) => {
            return tags.some((tag: string) => tag.toLowerCase() === toolTag.toLowerCase() )
        })
    }

    static toolsWithTags(tools: TeachingTool[], tags: string[]): TeachingTool[] {
        const results: TeachingTool[] = []
        tools.forEach((tool: TeachingTool) => {
          if (tool.tagsMatchAny(tags)) {
            results.push(tool)
          }
        })
        return results
    }

    get icon(): string {
        if (this.contentType.toLowerCase() === 'link') { return 'mt-link' }
        if (this.contentType.toLowerCase() === 'pdf') { return 'mt-document' }
        if (this.contentType.toLowerCase() === 'video') { return 'mt-play-selected' }
        return ''
    }
}
